<template>
    <div class="library_index">
        <div class="top">
            <el-row>
                <el-col :span="19">
                    <el-radio-group
                        v-model="dayNum"
                        size="medium"
                    >
                        <el-radio-button label="周活"></el-radio-button>
                        <el-radio-button label="月活"></el-radio-button>
                    </el-radio-group>
                    <location-selector ref="locSelector" hasProvinceAll hasCityAll @change="listSchoolActive()"
                                       v-model="locationArray"></location-selector>
                    <el-select
                        size="medium"
                        v-model="selectBusiness"
                        style="width: 160px;"
                        v-if="!isManageBusiness"
                    >
                        <el-option label="全部经销商" :value="''"></el-option>
                        <el-option
                            :label="item.bussinessName"
                            :value="item.bussinessNumber"
                            :key="item.id"
                            v-for="item in businessList"
                        ></el-option>
                    </el-select>
                    <el-select
                        size="medium"
                        v-model="schoolType"
                        style="width: 140px;"
                    >
                        <el-option label="全部学校类型" :value="0"></el-option>
                        <el-option
                            :label="item.schoolTypeName"
                            :value="item.schoolType"
                            :key="item.schoolType"
                            v-for="item in schoolStagesList"
                        ></el-option>
                    </el-select>
                    <a
                        :href="downLoadHref"
                        target="_blank"
                        download="activityName"
                    >
                        <el-button
                            type="primary"
                            size="medium"
                        >导出
                        </el-button>
                    </a>
                </el-col>
                <el-col :span="5">
                    <el-input
                        placeholder="请输入学校名称"
                        size="medium"
                        icon="el-icon-search"
                        @change="handleInputChange"
                        v-model.trim="query.schoolName"
                    >
                        <el-button
                            slot="append"
                            icon="el-icon-search"
                            @click="handleInputChange"
                        ></el-button>
                    </el-input>
                </el-col>
            </el-row>
        </div>

        <el-table
            stripe
            :data="activityList"
            :height="`${windowHeight - 210}px`"
            border
            style="width: 100%"
        >
            <el-table-column
                label="id"
                align="center"
                width="100"
                prop="schoolId"
            ></el-table-column>
            <el-table-column
                label="学校"
                width="300"
                align="center"
                prop="schoolName"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                label="学段"
                align="center"
                show-overflow-tooltip
            >
                <template slot-scope="scope">
                    <span>{{filterSchoolType(scope.row.type)}}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="区域"
                align="center"
                prop="orgAreaName"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                label="经销商"
                align="center"
                prop="bussinessName"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                label="客服名称"
                align="center"
                prop="customerName"
                show-overflow-tooltip
            ></el-table-column>
            <el-table-column
                label="活跃用户数"
                align="center"
                prop="userActiveCount"
            ></el-table-column>
            <el-table-column
                label="活跃次数"
                align="center"
                prop="count"
            ></el-table-column>
            <el-table-column
                label="活跃等级"
                align="center"
            >
                <template slot-scope="scope">
          <span>
            <el-tag
                type="danger"
                effect="dark"
                size="mini"
                v-if="scope.row.count > 10000"
            >活跃</el-tag>
            <el-tag
                type="warning"
                effect="dark"
                size="mini"
                v-else-if="scope.row.count >= 1000"
            >不太活跃</el-tag>
            <el-tag
                type="info"
                effect="dark"
                size="mini"
                v-else
            >不活跃</el-tag>
          </span>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="query.pageNo"
                :page-sizes="[10,20,30, 50]"
                :page-size="query.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
            >
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import LocationSelector from '@/components/LocationSelector';
    import {queryBussinessListAll} from "@/api/empower";
    import {
        getSchoolStages,
        isBusinessManager,
        listSchoolActive,
    } from "@/api/dataAnalysis";
    import mixin from "@/mixins/windowResize";

    export default {
        name: "activityIndex",
        data() {
            return {
                downLoadHref: "",
                dayNum: "周活",
                locationArray: ['0', '0', '0'],
                selectBusiness: '',
                businessList: [],
                schoolType: 0,
                schoolStagesList: [],
                total: null,
                isManageBusiness: false,
                query: {
                    schoolName: "", //书籍名称
                    pageNo: 1, //页数
                    pageSize: 20, //条数
                },
                activityList: [],
            };
        },
        components: {LocationSelector},
        watch: {
            dayNum() {
                this.listSchoolActive();
            },
            selectBusiness() {
                this.listSchoolActive();
            },
            schoolType() {
                this.listSchoolActive();
            },
        },
        mixins: [mixin],
        //获取渲染数据当数据加载完成后执行(生命周期中的钩子函数)
        created() {
            this.isBusinessManager();
            this.queryBussinessListAll();
            this.getSchoolStages();
        },
        methods: {
            isBusinessManager() {
                isBusinessManager().then((data) => {
                    if (data.result) {
                        this.isManageBusiness = true;
                    }
                    this.listSchoolActive();
                });
            },
            queryBussinessListAll() {
                queryBussinessListAll().then((data) => {
                    if (data.length) {
                        this.businessList = data;
                    }
                });
            },
            getSchoolStages() {
                getSchoolStages().then((data) => {
                    if (data.length) {
                        this.schoolStagesList = data;
                    }
                });
            },
            listSchoolActive() {
                let orgAreaCode = this.$refs.locSelector.getCode();
                this.downLoadHref =
                    (global.command === "production"
                        ? "https://wyms.weixiaojia.cn/wyms"
                        : "http://wyms.weixiaojia.net/wyms") +
                    "/schoolActive/downLoad?areaCode=" +
                    (orgAreaCode == 0 ? '' : orgAreaCode) +
                    "&bussinessNumber=" +
                    (this.isManageBusiness ? "" : this.selectBusiness) +
                    "&days=" +
                    (this.dayNum === "月活" ? -30 : -7) +
                    "&schoolName=" +
                    this.query.schoolName +
                    "&schoolType=" +
                    this.schoolType +
                    "&token=" +
                    this.$store.getters.token;

                const query = {
                    areaCode: orgAreaCode == 0 ? '' : orgAreaCode,
                    bussinessNumber: this.isManageBusiness ? "" : (this.selectBusiness || ''),
                    days: this.dayNum === "月活" ? -30 : -7,
                    schoolType: this.schoolType,
                };
                listSchoolActive(Object.assign(this.query, query)).then((data) => {
                    if (data.dataList.length) {
                        this.activityList = data.dataList;
                        this.total = data.pagination.total;
                    } else {
                        this.activityList = [];
                        this.total = null;
                    }
                });

            },
            handleInputChange() {
                this.query.pageNo = 1;
                this.listSchoolActive();
            },
            //切换条数
            handleSizeChange(val) {
                this.query.pageSize = val;
                this.query.pageNo = 1;
                this.listSchoolActive();
            },
            //切换页数
            handleCurrentChange() {
                this.listSchoolActive();
            },
            filterSchoolType(type) {
                if (this.schoolStagesList && this.schoolStagesList.length) {
                    const schoolTypeIds = this.schoolStagesList.map(
                        (item) => item.schoolType
                    );
                    const schoolTypeNames = this.schoolStagesList.map(
                        (item) => item.schoolTypeName
                    );
                    if (type && schoolTypeIds.indexOf(type) > -1) {
                        return schoolTypeNames[schoolTypeIds.indexOf(type)];
                    } else {
                        return "-";
                    }
                } else {
                    return "-";
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import "./../../styles/mixin";

    .library_index {
        padding: 12px;

        .top {
            padding-bottom: 10px;
        }

        .button {
            padding: 10px 0;

            span {
                cursor: pointer;
                border: 1px solid #dddddd;
                border-radius: 5px;
                text-align: center;
                display: inline-block;
                width: 80px;
                padding: 5px;
                font-size: 14px;
                margin-right: 10px;
            }

            .color {
                background-color: #12b7f5;
                color: #fff;
                border-color: #12b7f5;
            }
        }

        .time-table {
            @include scrollBar;

            .book {
                overflow: hidden;

                .li:hover {
                    i {
                        display: block;
                    }
                }

                .li {
                    position: relative;
                    width: 140px;
                    height: 200px;
                    text-align: center;
                    float: left;
                    margin-right: 37px;
                    margin-bottom: 20px;
                    background: no-repeat center center / cover;
                    /*box-shadow: 0 0 10px #eee;*/

                    i {
                        display: none;
                        font-size: 20px;
                        cursor: pointer;
                    }

                    .el-icon-delete {
                        position: absolute;
                        color: red;
                        right: 5px;
                        top: 5px;
                    }

                    .el-icon-edit {
                        position: absolute;
                        color: #409eff;
                        right: 30px;
                        top: 5px;
                    }

                    .book__info {
                        cursor: pointer;
                        background-color: rgba(0, 0, 0, 0.5);
                        color: #fff;
                        position: absolute;
                        bottom: 0;
                        padding: 2px;
                        width: 100%;

                        div {
                            white-space: nowrap;
                            text-overflow: ellipsis;
                            overflow: hidden;
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/dataStatistics/activityIndex.vue